import ContractInits from "../config/contractsInit";

export const checkWeb3 = () => {
  return async (dispatch) => {
    dispatch({
      type: "checkWeb3",
      payload: await ContractInits.init(),
    });
  };
};

export const checkWeb3React = (load) => {
  // alert(load.address);
  return async (dispatch) => {
    dispatch({
      type: "checkWeb3",
      payload: load,
    });
  };
};

export const web3React = (chainId, account) => {
  // console.log('Layout action', chainId, account)
  return {
    type: "checkWeb3React",
    payload: { chainId, account },
  };
};

export const onSetStakeLoading = (load) => {
  return {
    type: "onStakeLoad",
    payload: load,
  };
};

export const onSetTransactionMessage = (message) => {
  return {
    type: "onStakeMessage",
    payload: message,
  };
};

export const onSetUnStakeLoading = (load) => {
  return {
    type: "onUnStakeLoad",
    payload: load,
  };
};

export const onToast = (message) => {
  return {
    type: "onToastOpen",
    payload: { message, open: true },
  };
};

export const handleToastClose = () => {
  return {
    type: "onHandleToastClose",
    payload: false,
  };
};

export const themeModeChanged = (themeMode) => {
  return {
    type: "onThemeModeChanged",
    payload: themeMode,
  };
};

export const sideDrawerClicked = () => {
  return {
    type: "onSideDrawerClicked",
  };
};

export const LogoutAppAction = () => {
  return {
    type: "LOGOUT_APP",
  };
};
